import { useState } from "react";
import { PageHeader } from "../../../components/header/PageHeader";
import Table, { tableOptions } from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { childCheckerListTable, childCheckerOptions } from "../../../shared/tableObjects/admin/childCheckerListTable";
import { ChildSearchComponent } from "../../../components/form/components/ChildSearchComponent";
import { eventEmitter } from "../../../shared/event";

export default function ChildCheckerList() {
  const apiClient = useApiClient("AdminApplication");

  const [firstName, setFirstName] = useState<any>("");
  const [lastName, setLastName] = useState<any>("");
  const [dateOfBirth, setDateOfBirth] = useState<any>(undefined);
  const [tableOptions, setTableOptions] = useState<tableOptions>(childCheckerOptions);

  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "Child Checker",
      icon: "open-books-icon icon-spec",
    },
  ];

  const clearSearch = () => {
    setFirstName("");
    setLastName("");
    setDateOfBirth(undefined);
    eventEmitter.removeListener("clearSearch", clearSearch);
  };

  const handleSearch = (newFirstName: string, newLastName: string, newDateOfBirth: Date | undefined) => {
    setFirstName(newFirstName);
    setLastName(newLastName);
    setDateOfBirth(newDateOfBirth);

    let filters = {};
    if (newFirstName != null) {
      filters = { ...filters, ["firstName"]: { searchFilter: newFirstName } };
    }
    if (newLastName != null) {
      filters = { ...filters, ["lastName"]: { searchFilter: newLastName } };
    }
    if (newDateOfBirth != null) {
      filters = { ...filters, ["dateOfBirth"]: { searchFilter: newDateOfBirth?.toString() } };
    }
    setTableOptions({
      ...tableOptions,
      filters: filters,
    });
    eventEmitter.once("clearSearch", clearSearch);
  };

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table child-checker">
        <ChildSearchComponent search={handleSearch}></ChildSearchComponent>

        {(firstName != "" || lastName != "" || dateOfBirth != undefined) && (
          <Table
            key={`${firstName}-${lastName}-${dateOfBirth}`}
            apiClient={apiClient}
            route={"childChecker"}
            label={""}
            columns={childCheckerListTable("applications")}
            tableOptions={tableOptions}
          />
        )}
      </div>
    </>
  );
}
